/**
 * Cells of a CSV opened in a spreadsheet: a text starting with `=`, `+`, `-`, `@`, a tab or a carriage
 * return is read as a formula (a customer named `=HYPERLINK(…)` on a web order would run in the
 * accountant's Excel). Such a text gets a leading apostrophe, which spreadsheets show as plain text.
 * Numbers stay numbers: a value made of digits only (`-12,50`, `+33 6 12 34 56 78`) is left as is.
 * Every CSV the ERP writes goes through it (`csvText`, the La Poste files).
 */
const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[-+]?\d[\d\s.,]*$/;

export function csvSafeText(value: string): string {
  return FORMULA_START.test(value) && !PLAIN_NUMBER.test(value) ? `'${value}` : value;
}
